var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorld(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53127 12C7.53127 10.9727 7.56787 9.94364 7.64039 8.93747H0.393047C0.13425 9.92494 0 10.9521 0 12C0 13.0479 0.13425 14.0751 0.393047 15.0625H7.64034C7.56788 14.0564 7.53127 13.0273 7.53127 12Z",
    fill: "#473F68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 12C8.9375 13.0475 8.97537 14.0743 9.04878 15.0625H14.9512C15.0246 14.0743 15.0625 13.0475 15.0625 12C15.0625 10.9525 15.0246 9.92574 14.9512 8.93747H9.04878C8.97537 9.92574 8.9375 10.9525 8.9375 12Z",
    fill: "#473F68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6072 8.93747H16.3599C16.4323 9.94364 16.4689 10.9727 16.4689 12C16.4689 13.0273 16.4323 14.0564 16.3599 15.0625H23.6072C23.866 14.0751 24.0002 13.0479 24.0002 12C24.0002 10.9521 23.866 9.92494 23.6072 8.93747Z",
    fill: "#473F68"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18018 16.4688C9.36186 18.071 9.64246 19.5379 10.0114 20.7826C10.6703 23.0051 11.4849 24 12 24C12.5151 24 13.3297 23.0051 13.9886 20.7826C14.3575 19.5379 14.6381 18.0709 14.8198 16.4688H9.18018Z",
    fill: "#473F68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8198 7.53122C14.6381 5.92898 14.3575 4.46203 13.9886 3.21736C13.3297 0.994828 12.5151 0 12 0C11.4849 0 10.6703 0.994828 10.0114 3.21736C9.64246 4.46208 9.36186 5.92903 9.18018 7.53122H14.8198Z",
    fill: "#473F68"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.143 7.53121C22.5473 6.04513 21.6515 4.68088 20.4853 3.51468C18.7578 1.7871 16.5959 0.651928 14.2461 0.209381C15.2382 1.83079 15.9052 4.51541 16.2329 7.53117H23.143V7.53121Z",
    fill: "#473F68"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2461 23.7906C16.5959 23.3481 18.7577 22.2129 20.4853 20.4852C21.6515 19.3191 22.5473 17.9549 23.143 16.4688H16.2329C15.9052 19.4845 15.2382 22.1692 14.2461 23.7906Z",
    fill: "#473F68"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.857178 16.4688C1.45287 17.9549 2.34865 19.3191 3.5148 20.4853C5.24243 22.2129 7.40426 23.3481 9.75401 23.7906C8.76195 22.1692 8.09496 19.4846 7.76726 16.4688H0.857178V16.4688Z",
    fill: "#473F68"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75401 0.209442C7.40426 0.651942 5.24243 1.78711 3.5148 3.51474C2.34865 4.68094 1.45287 6.04514 0.857178 7.53127H7.76726C8.09496 4.51547 8.76195 1.83085 9.75401 0.209442Z",
    fill: "#473F68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.abb568552ac9b7a8e6c81eb6ed3abcba.svg";
export { ForwardRef as ReactComponent };